import styled from 'styled-components'
import { Card, Form, Row, Col, Container } from 'react-bootstrap'
import { FaPencilAlt } from 'react-icons/fa'

export const DashboardContainer = styled.div`
  // position: fixed;
  top: 6vh;
  background-color: #1a1a1a;
  display: flex;
  flex-direction: column;
`

export const HeaderSection = styled.div`
  z-index: 100;
  background-color: #1a1a1a;
  padding: 1rem 0;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 1rem;
`

export const DashboardContent = styled(Container)`
  margin: 0 auto;
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 768px) {
    padding: 0 8px 16px;
    gap: 16px;
  }
`

export const HeaderCard = styled(Card)`
  border: none;
  background-color: #2d2d2d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  .card-body {
    background: linear-gradient(45deg, #402563, #2042ba);
    border-radius: 12px;
    padding: 1.5rem;
  }
`

export const ProjectHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ProjectTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  h1 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
  }
`

export const EditIcon = styled(FaPencilAlt)`
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  transition: color 0.2s;

  &:hover {
    color: #c787f6;
  }
`

export const ProjectMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
`

export const NameInput = styled(Form.Control)`
  max-width: 300px;
  font-size: 24px;
  font-weight: 600;
  background-color: #333333;
  border-color: #404040;
  color: #ffffff;

  &:focus {
    background-color: #404040;
    border-color: #0d6efd;
    color: #ffffff;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  }
`

export const SectionTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
`

export const StatCard = styled(Card)<{
  $variant?: 'primary' | 'info' | 'success' | 'warning' | 'purple'
}>`
  height: 100%;
  border: none;
  border-radius: 12px;
  background-color: #2d2d2d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(45, 45, 45, 0.7);
    border-radius: 12px;
    z-index: 1;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  }

  .card-body {
    background: ${(props) => {
      switch (props.$variant) {
        case 'primary':
          return 'linear-gradient(45deg, #0d47a1, #1976d2)'
        case 'info':
          return 'linear-gradient(45deg, #006064, #00acc1)'
        case 'success':
          return 'linear-gradient(45deg, #1b5e20, #43a047)'
        case 'warning':
          return 'linear-gradient(45deg, #e65100, #fb8c00)'
        case 'purple':
          return 'linear-gradient(45deg, #402563, #2042ba)'
        default:
          return 'linear-gradient(45deg, #402563, #2042ba)'
      }
    }};
    border-radius: 12px;
    padding: 1.5rem;

    @media (max-width: 768px) {
      padding: 1rem;
    }
  }
`

export const StatContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 576px) {
    gap: 12px;
  }
`

export const StatIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  font-size: 24px;
  background: rgba(255, 255, 255, 0.1);

  @media (max-width: 576px) {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
`

export const StatInfo = styled.div`
  flex: 1;

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;

    @media (max-width: 576px) {
      font-size: 20px;
    }
  }

  p {
    margin: 4px 0 0;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;

    @media (max-width: 576px) {
      font-size: 12px;
    }
  }
`

export const DetailCard = styled(Card)`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 12px;
  background-color: #2d2d2d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  .card-body {
    padding: 1.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: 768px) {
      padding: 1rem;
    }
  }
`

export const DetailHeader = styled.div`
  background: linear-gradient(45deg, #402563, #2042ba);
  padding: 16px 24px;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;

    @media (max-width: 576px) {
      font-size: 16px;
    }
  }
`

export const DetailGrid = styled.div`
  display: grid;
  gap: 16px;
  padding: 16px;

  @media (max-width: 768px) {
    gap: 12px;
    padding: 12px;
  }
`

export const DetailItem = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px;
  align-items: baseline;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`

export const DetailLabel = styled.span`
  color: #8c8c8c;
  font-size: 14px;
  font-weight: 500;

  @media (max-width: 576px) {
    font-size: 12px;
  }
`

export const DetailValue = styled.span`
  color: #ffffff;
  font-size: 14px;
  word-break: break-word;

  @media (max-width: 576px) {
    font-size: 13px;
  }
`

export const MainGridContainer = styled(Row)`
  margin-bottom: 24px;

  > div {
    margin-bottom: 24px;
  }
`

export const MainGridColumn = styled(Col)`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`

export const FullWidthSection = styled.div`
  width: 100%;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 32px;
  }

  @media (max-width: 768px) {
    margin-bottom: 24px;

    &:last-child {
      padding-bottom: 24px;
    }
  }
`

export const ChartContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  margin-bottom: 16px;

  &.model-performance {
    height: 100%;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  &.class-distribution {
    height: 100%;
    margin-bottom: 0;
  }

  canvas {
    width: 100% !important;
    height: 100% !important;
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(45, 45, 45, 0.7);
    border-radius: 8px;
  }

  @media (max-width: 992px) {
    height: 350px;
  }

  @media (max-width: 768px) {
    height: 300px;
  }

  @media (max-width: 576px) {
    height: 250px;
    margin-bottom: 8px;
  }
`

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
`

export const DatasetSelect = styled(Form.Select)`
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  width: auto;
  min-width: 150px;
  margin-left: 16px;

  &:focus {
    background-color: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    color: #ffffff;
    box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.15);
  }

  option {
    background-color: #2d2d2d;
    color: #ffffff;
  }
`

export const StatsRow = styled(Row)`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`

export const StatsCol = styled(Col)`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`
